<template>
<main>
  <div class="container">
    <div class="row">
      <ul id="month-selector">
        <li
          v-for="(month, index) in months"
          :key="month.idx"
          :class="{ 'active': index === monthActive }"
          @click="showMonthsData($event, index)"
        >{{ month.label }}</li>
        <li class="add-month" @click="addMonthData()">Add new Month</li>
      </ul>
    </div>
    <div class="row header">
      <div class="col-md-3 offset-md-6">
        <h2>Novo Nordisk MS%</h2>
      </div>
      <div class="col-md-3">
        <h2>Novo Nordisk SoG%</h2>
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="germany">Germany</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('GERMANY.ms')"
        @input="setValue('GERMANY.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('GERMANY.sog')"
        @input="setValue('GERMANY.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="latam">Latam</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('LATAM.ms')"
        @input="setValue('LATAM.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('LATAM.sog')"
        @input="setValue('LATAM.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="china">China</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('CHINA.ms')"
        @input="setValue('CHINA.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('CHINA.sog')"
        @input="setValue('CHINA.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="japan">Japan</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('JAPAN.ms')"
        @input="setValue('JAPAN.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('JAPAN.sog')"
        @input="setValue('JAPAN.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="apac">APAC</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('APAC.ms')"
        @input="setValue('APAC.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('APAC.sog')"
        @input="setValue('APAC.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="seemea">SEEMEA</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('SEEMEA.ms')"
        @input="setValue('SEEMEA.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('SEEMEA.sog')"
        @input="setValue('SEEMEA.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="nwe">NWE</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('NWE.ms')"
        @input="setValue('NWE.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('NWE.sog')"
        @input="setValue('NWE.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-6">
        <h3 class="total-io">Total IO</h3>
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('TOTAL-IO.ms')"
        @input="setValue('TOTAL-IO.ms', $event.target.value)"
      >
      </div>
      <div class="col-md-3">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('TOTAL-IO.sog')"
        @input="setValue('TOTAL-IO.sog', $event.target.value)"
      >
      </div>
    </div>
    <div class="row action-bar">
      <div class="col-md-12" style="text-align: right; margin-top: 1em;">
        <button
          type="submit"
          class="btn btn-primary btn-save"
          :disabled=hasChanges
          @click="save()"
        >Save Data</button>
      </div>
    </div>
  </div>
</main>
</template>

<script>
import DataSetup from '../dataSetup'

export default {
  name: 'SogForm',

  data () {
    return {
      changed: false,
      monthActive: 0,
      monthActiveLabel: '',
      months: []
    }
  },

  created () {
    let parsedJsonData = JSON.parse(window.localStorage.getItem('history-wall'))
    if (parsedJsonData) {
      this.data = parsedJsonData.history
      let cntMonths = this.data[0].data['ms'].length
      for (let r = 0; r < cntMonths; r++) {
        let date = new Date(this.data[0].data['ms'][r].x)
        this.months.push({'idx': r, 'label': date.toLocaleString('default', { month: 'long' }) + ' ' + date.getFullYear()})
      }
      this.monthActive = cntMonths - 1
      this.monthActiveLabel = this.data[0].data['ms'][cntMonths - 1].x
    }
  },

  methods: {
    getValue (path) {
      const [name, fieldName] = path.split('.')
      let retVal = 0

      if (this.data) {
        let region = this.data.find(region => region.name === name)
        if (region) {
          let field = region.data
          if (field) {
            retVal = field[fieldName][this.monthActive].y
          }
        }
      }
      return retVal
    },

    setValue (path, value) {
      const [name, fieldName] = path.split('.')
      if (this.data) {
        let region = this.data.find(region => region.name === name)
        if (region) {
          let field = region.data[fieldName]
          if (field) {
            let m = field.find(field => field.x === this.monthActiveLabel)
            if (m) {
              m.y = parseFloat(value)
              this.changed = true
            }
          }
        }
      }
    },

    save () {
      let data = JSON.parse(window.localStorage.getItem('history-wall'))
      if (data) {
        let regions = this.data.length
        let monthCnt = this.data[0].data.ms.length - 13
        for (let r = 0; r < regions; r++) {
          this.data[r].data.ms.splice(0, monthCnt)
          this.data[r].data.sog.splice(0, monthCnt)
        }

        let lastMonth = this.data[0].data.ms.length - 1
        this.months.splice(0, monthCnt)
        this.monthActive = lastMonth
        this.monthActiveLabel = this.data[0].data['ms'][lastMonth].x

        data.history = this.data
        window.localStorage.setItem('history-wall', JSON.stringify(data))
        DataSetup.saveData()
        this.changed = false
      } else {
        alert('Beim speichern ist ein Datenfehler aufgetreten.')
      }
    },

    showMonthsData (evt, month) {
      let lis = document.querySelectorAll('#month-selector li.active')
      if (lis) {
        lis.forEach(function (li) {
          li.classList.remove('active')
        })
      }
      evt.target.classList.add('active')
      this.monthActive = month
      this.monthActiveLabel = this.data[0].data['ms'][month].x

      this.$forceUpdate()
    },

    addMonthData () {
      let newDate = new Date(this.data[0].data['ms'][this.months.length - 1].x)
      newDate.setMonth(newDate.getMonth() + 1)
      this.months.push({'idx': this.months.length, 'label': newDate.toLocaleString('default', { month: 'long' }) + ' ' + newDate.getFullYear()})

      let regions = this.data.length
      let newMonth = this.buildDateString(newDate.getFullYear(), (newDate.getMonth() + 1), 15)
      for (let r = 0; r < regions; r++) {
        this.data[r].data.ms.push({'x': newMonth, 'y': 0})
        this.data[r].data.sog.push({'x': newMonth, 'y': 0})
      }

      let lis = document.querySelectorAll('#month-selector li.active')
      if (lis) {
        lis.forEach(function (li) {
          li.classList.remove('active')
        })
      }

      let monthCnt = this.data[0].data.ms.length - 1
      this.monthActive = monthCnt
      this.monthActiveLabel = this.data[0].data['ms'][monthCnt].x
    },

    buildDateString (year, month, day) {
      if (month > 12) {
        month = month - 12
        year++
      }
      var m = (month < 10) ? '0' + month : month
      return year + '-' + m + '-' + day
    }
  },
  computed: {
    hasChanges () {
      return !this.changed
    }
  }
}
</script>

<style scoped>
  main .header {
    margin-top: 0;
  }

  #sog {
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    padding: 20px;
    margin-top: 10px;
  }
  #month-selector {
    display: table;
    position: relative;
    list-style-type: none;
    padding: 0;
    width: 100%;
    height: 62px;
    margin: 1em 0;
  }

  #month-selector li {
    display: table-cell;
    padding: .3em;
    text-align: center;
    vertical-align: middle;
    font-size: 14px;
    line-height: 1.2em;
    background-color: white;
    color: black;
    border-left: 1px solid #1E4D83;
    border-right: 1px solid #1E4D83;
    cursor: pointer;
    transition: all .3s ease-in-out;
  }
  #month-selector li.active {
    background-color: #007bff;
    color: white;
  }
  #month-selector li:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  #month-selector li:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #02A12A;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/sog.vue